export default __webpack_public_path__ + "static/media/library-new.9f52ade2.svg";